module.exports = __webpack_public_path__ + "static/img/11.190d2bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/11.jpg
// module id = WHwl
// module chunks = 1